import Cookies from 'js-cookie';

export const getToken = (): string => {
  const token = Cookies.get('jwt');
  return token ? token : '';
};
